import { RefObject, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
import useUiuxStore from 'src/store/useUiuxStore';

import { SYS2010_R01Dto } from '../Dto_SYS2010_R01';

interface UseSYS2010_R01ModalProps {
	updateSYS2010_R01List: (index: number, data: SYS2010_R01Dto) => void;
	gridRef: RefObject<AgGridReact<SYS2010_R01Dto> | null>;
}

export function useSYS2010_R01Modal({
	updateSYS2010_R01List,
	gridRef,
}: UseSYS2010_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const handlePopupClose = useCallback(() => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	}, [gridRef]);

	const settingCodeSearchModalProps = useCallback((
		category: string,
		search: string,
		isInfo: boolean,
		handleFoucsId: string,
		originalData: SYS2010_R01Dto,
		valueIndex: number,
	) => {
		const wrapperOptionMap: Record<string, { size: string; width: number; overlay: boolean }> = {
			upMenu: { size: 'half', width: 20, overlay: true },
		};

		setCodeSearchModalProps({
			category,
			search,
			formName: 'SYS2010_R01',
			isInfo,
			handleFoucsId,
			onClear: () => {
				if (handleFoucsId === 'upMenu') {
					updateSYS2010_R01List(valueIndex, {
						...originalData,
						upMenu: '',
						isModified: !originalData.inserted,
					});
				}
				handlePopupClose();
			},
			onConfirm: (data: any) => {
				if (handleFoucsId === 'upMenu') {
					updateSYS2010_R01List(valueIndex, {
						...originalData,
						upMenu: data.menuCd ?? '',
						isModified: !originalData.inserted,
					});
				}
			},
			wrapperOption: wrapperOptionMap[handleFoucsId] ?? { size: 'half', width: 20, overlay: true },
		});
	}, [setCodeSearchModalProps, updateSYS2010_R01List, handlePopupClose]);

	return { settingCodeSearchModalProps, handlePopupClose };
}
